var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 72,
    viewBox: "0 0 65 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.3419 71.5C54.4261 71.5 64.2222 61.9487 64.2222 50.1666C64.2222 38.3846 54.4261 28.8333 42.3419 28.8333C30.2577 28.8333 20.4615 38.3846 20.4615 50.1666C20.4615 61.9487 30.2577 71.5 42.3419 71.5Z",
    fill: "#4AD3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8633 38.8333C49.8633 17.8333 25.9316 1.5 25.9316 1.5C25.9316 1.5 2 17.8333 2 38.8333C2 45.0217 4.5213 50.9567 9.00937 55.3325C13.4974 59.7084 19.5845 62.1667 25.9316 62.1667C32.2787 62.1667 38.3658 59.7084 42.8539 55.3325C47.342 50.9567 49.8633 45.0217 49.8633 38.8333Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9316 62.1667V1.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9316 15.5001L49.8633 38.8334",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9316 29.5L46.9524 49.9952",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9316 43.5001L40.2914 57.5009",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.b3e2ccb40fa9b73ff36ec1a784682c34.svg";
export { ForwardRef as ReactComponent };